/*
 * Copyright (c) 2025 AirAsia Berhad (Malaysia). All rights reserved.
 *
 * This software is proprietary and confidential. Unauthorized copying of this file,
 * via any medium, is strictly prohibited. Do not distribute, copy, modify, or reuse
 * any part of this code without explicit written permission from AirAsia Move.
 *
 * For internal use only.
 */

/**
 * Checks whether the current runtime environment is running on a China domain
 * (e.g., airasia.cn, www.airasia.cn, or any domain with a .cn TLD).
 */
import { Platform } from 'react-native';
export const isChinaDomain = (): boolean => {
  if (
    Platform.OS !== 'web' ||
    typeof window === 'undefined' ||
    !window.location?.hostname
  )
    return false;
  const hostname = window.location.hostname.toLowerCase();
  return hostname.endsWith('airasia.cn') || hostname.split('.').pop() === 'cn';
};
